export const SITE_NAME = 'PULSE';
export const SITE_FULL_NAME = 'PULSE - ゲーム体験を記録できる究極のゲームライブラリ';
